import React from "react";
import { connect } from "react-redux";

// import { Row, Col, Form, Button, Collapse, Card } from "react-bootstrap";
import { Col, Form, Button, Card } from "react-bootstrap";

import 'react-phone-number-input/style.css';
import PhoneInput, {isValidPhoneNumber} from 'react-phone-number-input';
import { generateNumericalStringNotAllSame } from "utils/math";

import { withT } from "services/translation/";

import Loading from "components/Loading";

import Icon from "components/Icons/Icon";

import { Tooltip } from "components/Common/Tooltip/";

import {
  requestAddKeyholderStart,
  requestAddKeyholderNotified
} from "services/redux/actions";
import {
  requestAddSinglesitecontactStart,
  requestAddSinglesitecontactNotified
} from "services/redux/actions/singleSites";

import { getPathRootFromRoute } from "services/redux/selectors/app/";
import { getEnterpriseFromRoute } from "services/redux/selectors/enterprises";

import Alert from "components/Common/Alert";

import "./Keyholders.scss";

class Add extends React.Component {
  state = {
    open: false,
    internationalPhoneNumber: "",
    invalidPhoneNumber: "",
    invalidPassword: "",
    passwordText: "",
    showPassword: false,
    passwordInputFocus: false,
    showSmsOption: false,
  };
  addKeyholder = () => {
    const { dispatch, origin, enterprise_site_id, sudo_site_id, total, pathRoot, enterprise } = this.props;

    const keyholder = {};
    document
      .querySelectorAll("#AddKeyholder input")
      .forEach(input => {
        const inputName = input.name.slice(8); // remove the "contact_" bit from the field name
        if (inputName === "send_sms") {
          if (input.checked) {
            keyholder['sms'] = "Y";
          }
        } else if (inputName === "phone" && (pathRoot === "sites" || (enterprise && enterprise.single_sites))) {
          keyholder[inputName] = this.state.internationalPhoneNumber;
        } else {
          keyholder[inputName] = input.value;
        }
      });

    if (origin === "SingleSite") {
      dispatch(
        requestAddSinglesitecontactStart({
          sudo_site_id,
          params: {
            ...keyholder,
            position: total + 1,
          }
        })
      );
      this.setState({
        passwordText: "",
        internationalPhoneNumber: "",
        invalidPhoneNumber: "",
        invalidPassword: ""
      });
    } else {
      dispatch(
        requestAddKeyholderStart({
          params: {
            ...keyholder,
            position: total + 1,
            enterprise_site_id,
            sudo_site_id,
          }
        })
      );
      this.setState({
        passwordText: "",
        internationalPhoneNumber: "",
        invalidPhoneNumber: "",
        invalidPassword: "",
      });
    };
  };
  componentDidUpdate() {
    const { origin, t, success, dispatch } = this.props;

    if (success) {
      if (origin === "SingleSite") {
        dispatch(requestAddSinglesitecontactNotified());
      } else {
        dispatch(requestAddKeyholderNotified());
      }

      this.setState({
        open: false,
        showSmsOption: false,
        invalidPhoneNumber: "",
        invalidPassword: "",
      });

      Alert({
        text: t("success_message"),
        icon: "success"
      });
    }
  }
  render() {
    const { open } = this.state;
    const { t, site, loading, enterprise, pathRoot } = this.props;
    const { internationalPhoneNumber, invalidPhoneNumber, invalidPassword, passwordText, showPassword, passwordInputFocus, showSmsOption } = this.state;

    const form = open && (
      <Card bg="light">
        <Card.Body>
          <Form
            className="mt-2"
            onSubmit={e => {
              e.preventDefault();
              let invalidInputs = false;

              if (pathRoot === "sites" || (enterprise && enterprise.single_sites)) {
                if (internationalPhoneNumber && !isValidPhoneNumber(internationalPhoneNumber)) {
                  this.setState({ invalidPhoneNumber: "Invalid phone number" });
                  invalidInputs = true;
                }

                const passwordInput = document.getElementById("contact_password");
                if (String(passwordInput.value) !== "") {
                  const regex = /^[0-9]{4,6}$/;
                  if (!regex.test(String(passwordInput.value))) {
                    this.setState({ invalidPassword: "Invalid passcode" });
                    invalidInputs = true;
                  }
                }
              }

              if (!invalidInputs) {
                this.addKeyholder();
              }
            }}
            id="AddKeyholder">
            <Form.Row>
              {[
                {
                  key: "contact_name",
                  type: "text",
                  required: true,
                },
                {
                  key: "contact_email", // naming it differently to try and stop auto-fills
                  type: "email",
                  required: false,
                },
                {
                  key: "contact_phone",
                  type: "phone",
                  required: false,
                },
                {
                  key: "contact_job_title",
                  type: "text",
                  required: false,
                },
              ].map(({ key, type, required }) => (
                <Form.Group
                  key={key}
                  controlId={"formGroup" + key}
                  as={Col}
                  sm="6">
                  <Form.Label>{t(key.slice(8))}</Form.Label>

                  {(key === "contact_phone" && (pathRoot === "sites" || (enterprise && enterprise.single_sites)))
                    ? <div>
                        <PhoneInput
                          className="pl-1"
                          international
                          countryCallingCodeEditable={false}
                          defaultCountry={(site && (site.country || site.country_code)) || "GB"}
                          name={key} 
                          required={required}
                          value={internationalPhoneNumber}
                          onChange={(value) => {
                            const phoneNumberValue = (value !== undefined) ? value : "";
                            const passwordInput = document.getElementById("contact_password");
                            const passwordValue = passwordInput ? passwordInput.value : "";
                            this.setState({
                              internationalPhoneNumber: phoneNumberValue,
                              invalidPhoneNumber: "",
                              showSmsOption: phoneNumberValue !== "" && passwordValue !== "",
                            })
                          }}
                          autoComplete="do-not-autofill"
                          limitMaxLength={true}
                          rules={{ validate: isValidPhoneNumber }}
                        />
                        <div style={{ width: "100%" }} className="d-flex justify-content-end text-danger">{invalidPhoneNumber}</div>
                      </div>
                    : 
                    <Form.Control type={type} name={key} required={required} autoComplete="do-not-autofill" />
                  }
                </Form.Group>
              ))}

              {(pathRoot === "sites" || (enterprise && enterprise.single_sites)) &&
                <Form.Group
                  as={Col}
                  sm="6"
                >
                  <Form.Label>{t("password")}</Form.Label>
                  <div className="d-flex align-items-center">
                    <Tooltip
                      description="Enter numbers only, 4-6 digits in length."
                      placement="top"
                    >
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        className="text-muted"
                        style={{ borderRight: "none", borderRadius: "0.25rem 0 0 0.25rem" }}
                        id="contact_password"
                        name="contact_password"
                        autoComplete="new-password"
                        onFocus={() => this.setState({ passwordInputFocus: true })}
                        onBlur={() => this.setState({ passwordInputFocus: false })}
                        value={passwordText}
                        onChange={(e) => {
                          let validatedPasswordText = e.target.value.replace(/\D/g, ""); // remove anything that is not a number
                          validatedPasswordText = validatedPasswordText.substring(0, 6); // restrict to 6 digits - doing it this way works better for copy/paste than setting maxlength
                          this.setState({
                            passwordText: validatedPasswordText,
                            invalidPassword: "",
                          });

                          if (validatedPasswordText === "") {
                            this.setState({ showSmsOption: false });
                          } else {
                            this.setState({
                              showSmsOption: internationalPhoneNumber !== "",
                            });
                          }
                        }}
                      />
                    </Tooltip>
                    <div
                      className="form-control d-flex align-items-center"
                      style={{
                        borderLeft: "none",
                        borderRadius: "0 0.25rem 0.25rem 0",
                        width: "2.5rem",
                        padding: "0.5rem",
                        fontSize: "1rem",
                        borderColor: passwordInputFocus ? "#2c3e50" : "#ced4da",
                      }}
                      onClick={() => {
                        this.setState({
                          showPassword: !showPassword,
                        })
                      }}
                    >
                      <Tooltip
                        description={showPassword ? "Hide passcode" : "Show passcode"}
                        placement="top"
                      >
                        <Icon className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
                      </Tooltip>
                    </div>
                    <Tooltip
                      description="Generate a random passcode."
                      placement="top"
                    >
                    <Button
                      onClick={() => {
                        // generate a 4-digit numerical code
                        const generatedCode = generateNumericalStringNotAllSame(4);
                        this.setState({
                          passwordText: generatedCode,
                          showSmsOption: internationalPhoneNumber !== "",
                          invalidPassword: "",
                        });
                      }}
                    >Generate</Button>
                    </Tooltip>
                  </div>
                  <div style={{ width: "100%" }} className="d-flex justify-content-end text-danger">{invalidPassword}</div>
                </Form.Group>
              }

              {(pathRoot === "sites" || (enterprise && enterprise.single_sites)) && showSmsOption &&
                <Form.Group
                  as={Col}
                  sm="6"
                >
                  <Form.Label>{t("send_sms")}</Form.Label>
                  <div
                    className="d-flex align-items-center justify-content-start"
                    style={{ height: "calc(2.25rem + 2px)" }}
                  >
                    <Form.Control
                      type="checkbox"
                      defaultChecked={true}
                      className="text-muted ml-2"
                      style={{ height: "calc(1rem + 4px)", width: "calc(1rem + 4px)" }}
                      name="contact_send_sms"
                    />
                  </div>
                </Form.Group>
              }

              <Form.Group controlId="formGroupSubmit" as={Col} xs="12">
                <Button
                  disabled={loading}
                  variant="success"
                  type="submit"
                  className="float-right">
                  <Icon className="fas fa-address-card fa-lg pr-2" />

                  {t("button_submit")}
                  {loading && <Loading />}
                </Button>

                <Button
                  disabled={loading}
                  onClick={() => {
                    this.setState({
                      open: false,
                      passwordText: "",
                      showSmsOption: false,
                      internationalPhoneNumber: "",
                      invalidPhoneNumber: "",
                      invalidPassword: "",
                    });
                  }}
                  variant="primary"
                  className="float-right mr-2">
                  {/* <Icon className="fas fa-user-plus pr-2" /> */}

                  {t("button_cancel")}
                  {/* {loading && <Loading />} */}
                </Button>
              </Form.Group>
            </Form.Row>
          </Form>
        </Card.Body>
      </Card>
    );
    return (
      <>
        {!open && (
          <div>
            <Button
              onClick={() => this.setState({ open: true })}
              className="mr-2"
              aria-controls="AddKeyholder"
              aria-expanded={open}>
              <Icon className="fas fa-address-card fa-lg mr-1" />
              {t("title")}
            </Button>
            <Tooltip 
              placement="right"
              description="Help"
            >
              <Button
                variant="primary"
                style={{
                  height: "19px",
                  width: "19px",
                  borderRadius: "50%",
                  padding: "0",
                }}
                onClick={() => {
                  window.Intercom('showArticle', 6927381) 
                }}
              ><Icon 
                className="fas fa-question fa-xs"
                style={{
                  position: "relative",
                  bottom: "3px",
                }}
              /></Button>
            </Tooltip>
          </div>
        )}

        {form}
      </>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    loading: state.sites.current.keyholders.actions.add.loading === true,
    success: state.sites.current.keyholders.actions.add.success,
    enterprise: getEnterpriseFromRoute(state, props),
    pathRoot: getPathRootFromRoute(state),
  };
};
export default connect(mapStateToProps)(
  withT(Add, "site_overview.side_pane.keyholders.add")
);
